/* import __COLOCATED_TEMPLATE__ from './responsive-image.hbs'; */
/**

## Respsonsive Image

The responsive image component takes paths and outputs HTML for responsive images

```example
@title Basic Usage
@description

@hbs
{{responsive-image src=(hash 1x="/assets/images/img-welcomebannervideo.jpg"
                             2x="/assets/images/img-welcomebannervideo@2x.jpg")}}
```

@param {Integer} width - width for the image
@param {Integer} height - height for the image
@param {String} description - descriptive text for the image (`alt` text)
@param {Object[]} src - hash of paths to display at various pixel aspect ratios `(hash 1x="image.png" 2x="image2x.png")`

*/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { assert } from '@ember/debug';
import { inject as service } from '@ember/service';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'img',
  attributeBindings: ['width', 'height', 'description:alt', 'srcset', 'srcFallback:src', 'data-test-media-block-image'],
  width: null,
  height: null,
  src: null,
  description: null,
  assetMap: service(),
  srcset: computed('src', function () {
    const src = this.getAssetMapUrls(this.src);
    let srcset = `${src['1x']}`;
    for (const size in src) {
      if (size !== '1x') {
        srcset = `${srcset}, ${src[size]} ${size}`;
      }
    }
    return srcset;
  }),
  didReceiveAttrs() {
    this._super();
    const srcFallback = this.src?.['1x'];
    assert('You must pass at least one image path with a `1x` key to `responsive-image`', srcFallback);
    this.srcFallback = this.assetMap.resolve(srcFallback);
  },
  getAssetMapUrls(urlHash) {
    if (!this.assetMap) {
      throw new Error('Missing asset-map service');
    }
    return Object.fromEntries(Object.entries(urlHash).map(([size, src]) => {
      assert("ResponsiveImage: 'src' hash values should be strings", typeof src === 'string');
      const mappedSrc = this.assetMap.resolve(src);
      return [size, mappedSrc];
    }));
  }
});